import moment from 'moment';

import { ApiService } from '../../app-lite/api/api.service';

export class EventTimeService {
  $q            : ng.IQService;
  $translate    : ng.translate.ITranslateService;
  defaultColumns: Array<any>;
  workshopAPI   : ApiService;

  constructor (
    $q         : ng.IQService,
    $translate : ng.translate.ITranslateService,
    workshopAPI: ApiService
  ) {
    this.$q          = $q;
    this.$translate  = $translate;
    this.workshopAPI = workshopAPI;
  };

  clearMechanic ( eventTime : any ) : ng.IPromise<any> {
    return this.workshopAPI.patch('/event_time', eventTime, 'event_time');
  };

  configureUpdate ( event : any = {}, eventTime : any = {} ) : void {
    eventTime.estimated_hours = parseFloat(event.estimated_hours);
    eventTime.event_date      = event.event_date;
    eventTime.id              = event.id;
    eventTime.time            = event.local_start_time ? moment(event.local_start_time).format() : null;

    if (event.local_start_time) {
      eventTime.time = moment(event.local_start_time).format();
    }
  };

  delete ( id : string ) : ng.IPromise<any> {
    return this.workshopAPI.delete('/event_time', id);
  }

  refresh ( eventItem : any, eventTime : any ) : void {
    eventTime.estimated_hours = parseFloat(eventItem.quantity);
    eventTime.event_id        = eventItem.event_id;
    eventTime.event_item_id   = eventItem.id;
  };

  roundEstimatedHours ( eventTime : any ) : void {
    if (eventTime.estimated_hours) {
      eventTime.estimated_hours = parseFloat(eventTime.estimated_hours.toFixed(1));
    }
  };

  save ( COL_FIELD : any, eventTime : any ) : ng.IPromise<any> {
    const method = eventTime.id ? 'patch' : 'post';
    const url    = eventTime.id ? '/event_time' : '/event_times';

    eventTime.local_start_time = eventTime.time ? eventTime.event_date + moment(eventTime.time).format('THH:mm:ssZ') : null;
    eventTime.mechanic_id      = COL_FIELD ? eventTime.mechanic_id : null;

    return this.workshopAPI[method](url, eventTime, 'event_time');
  };

  saveSearched ( row : any, eventTime : any ) : ng.IPromise<any> {
    eventTime.local_start_time = moment(row.timestamp).format('YYYY-MM-DDTHH:mm:ssZ');
    eventTime.mechanic_id      = row.mechanic_id;

    return this.workshopAPI.post('/event_times', eventTime, 'event_time');
  };

  search ( afterTime : any, beforeTime : any, days : any, eventTime : any ) : ng.IPromise<any> {

    eventTime.after_time  = afterTime ? afterTime.format('HH:mm:ss') : null;
    eventTime.before_time = beforeTime ? beforeTime.format('HH:mm:ss') : null;
    eventTime.on_days     = days.sort();

    return this.workshopAPI.post('/event_times/next_available', eventTime);
  };
}